function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icon_view",
  "data-name": "icon/view",
  d: "M-8451,9108.5a9.258,9.258,0,0,1,8-5,9.259,9.259,0,0,1,8,5,9.262,9.262,0,0,1-8,5A9.263,9.263,0,0,1-8451,9108.5Zm1.782,0A7.581,7.581,0,0,0-8443,9112a7.581,7.581,0,0,0,6.219-3.5A7.583,7.583,0,0,0-8443,9105,7.583,7.583,0,0,0-8449.219,9108.5Zm4.448,1.011a2.007,2.007,0,0,1,0-2.024,2,2,0,0,1,1.771-.988,2,2,0,0,1,1.956,2,2,2,0,0,1-1.956,2h-.044A2,2,0,0,1-8444.771,9109.512Z",
  transform: "translate(8451.001 -9103.501)",
  fill: "#a5a5a5"
});

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.002,
    height: 9.999,
    viewBox: "0 0 16.002 9.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.b66af3a4.svg";
export { ForwardRef as ReactComponent };